import { Line } from './Line';

export const ILineServiceId = Symbol.for('ILineService');

export interface ILineService {
    getLines(calendarDay: string): Promise<Line[]>;
}
